import authApi from '@/api/auth';
import {getItem, setItem} from "@/helpers/persistanceStorage";
import router from "@/router";


const state = {
    isLoggedIn: null,
    isLoading: false,
    isSubmitting: false,
    phoneMsg: "",
    isPhoneInvalid: false,
    isCodeSend: false,
    isCodeInvalid: false,
    codeMsg: "",
    currentUser: null,
    authGoogleUrl: null,
    authFacebookUrl: null,
}

export const mutationTypes = {
    setIsLoading: '[auth] setIsLoading',
    registerStart: '[auth] registerStart',
    registerStop: '[auth] registerStop',
    registerSuccess: '[auth] registerSuccess',
    setIsPhoneInvalid: '[auth] setIsPhoneInvalid',
    setPhoneMsg: '[auth] setPhoneMsg',
    isCodeSend: '[auth] isCodeSend',
    setIsCodeInvalid: '[auth] setIsCodeInvalid',
    setCodeMsg: '[auth] setCodeMsg',
    setCurrentUser: '[auth] setCurrentUser',
    setIsLoggedIn: '[auth] setIsLoggedIn',
    updateFirstName: '[auth] updateFirstName',
    updateLastName: '[auth] updateLastName',
    updatePhone: '[auth] updatePhone',
    updateEmail: '[auth] updateEmail',
    setAuthGoogleUrl: '[auth] setAuthGoogleUrl',
    setAuthFacebookUrl: '[auth] setAuthFacebookUrl'
}

export const actionTypes = {
    sendCode: '[auth] sendCode',
    authByCode: '[auth] authByCode',
    authByEmail: '[auth] authByEmail',
    setCsrf: '[auth] setCsrf',
    getCsrf: '[auth] getCsrf',
    setAuthToken: '[auth] setAuthToken',
    getAuthToken: '[auth] getAuthToken',
    getCurrentUser: '[auth] getCurrentUser',
    updateCurrentUser: '[auth] updateCurrentUser',
    sendVerifyMailLink: '[auth] sendVerifyMailLink',
    verificationEmail: '[auth] verificationEmail',
    logout: '[auth] logout',
    getLang: '[auth] getLang',
    setLang: '[auth] getLang',
    setPassword: '[auth] setPassword'
}

export const getterTypes = {
    currentUser: '[auth] currentUser',
    isLoggedIn: '[auth] isLoggedIn',
    isLoading: '[auth] isLoading',
    authGoogleUrl: '[auth] authGoogleUrl',
    authFacebookUrl: '[auth] authFacebookUrl'
}

const getters = {
    [getterTypes.currentUser]: state => {
        return state.currentUser
    },
    [getterTypes.isLoggedIn]: state => {
        return Boolean(state.isLoggedIn)
    },
    [getterTypes.isLoading]: state => {
        return Boolean(state.isLoading)
    },
    [getterTypes.authGoogleUrl]: state => {
        return state.authGoogleUrl
    },
    [getterTypes.authFacebookUrl]: state => {
        return state.authFacebookUrl
    }
}

const mutations = {
    [mutationTypes.registerStart](state) {
        state.isPhoneInvalid = false
        state.isSubmitting = true
        state.phoneMsg = ''
    },
    [mutationTypes.registerStop](state) {
        state.isSubmitting = false
    },
    [mutationTypes.registerSuccess](state, token){
        state.isCodeSend = false
        state.codeMsg = ''
        state.isLoggedIn = true
        state.authToken = `Token ${token}`

        this.dispatch(actionTypes.setAuthToken, `Token ${token}`).then(() => {
            this.dispatch(actionTypes.getCurrentUser)
        })

    },
    [mutationTypes.setIsPhoneInvalid](state, value){
        state.isPhoneInvalid = value
    },
    [mutationTypes.setPhoneMsg](state, value){
        state.phoneMsg = value
    },
    [mutationTypes.isCodeSend](state, value){
        state.isCodeSend = value
    },
    [mutationTypes.setIsCodeInvalid](state, value){
        state.isCodeInvalid = value
    },
    [mutationTypes.setCodeMsg](state, value){
        state.codeMsg = value
    },
    [mutationTypes.setCurrentUser](state, value){
        state.currentUser = value
    },
    [mutationTypes.setIsLoggedIn](state, value){
        state.isLoggedIn = value
    },
    [mutationTypes.updateFirstName](state, value){
        state.currentUser.first_name = value
    },
    [mutationTypes.updateLastName](state, value){
        state.currentUser.last_name = value
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.updatePhone](state, value){
        state.currentUser.phone = value
    },
    [mutationTypes.updateEmail](state, value){
        state.currentUser.email = value
    },
    [mutationTypes.setAuthGoogleUrl](state, value){
        state.authGoogleUrl = value
    },
    [mutationTypes.setAuthFacebookUrl](state, value){
        state.authFacebookUrl = value
    },
}

const actions = {
    [actionTypes.sendCode](context, credentials) {
        context.commit(mutationTypes.registerStart)

        console.log(credentials)

        return new Promise(resolve => {
            authApi
                .sendCode(credentials)
                .then(response => {
                    context.commit(mutationTypes.registerStop)
                    console.log('response:', response)

                    if (response.data['results']['action'] === 'send_sms_code' &&
                        response.data['results']['status'] === 'ok'){

                        console.log("Send sms code is OK!")
                        context.commit(mutationTypes.isCodeSend, true)
                        resolve(response.data['results'])
                    }
                })
                .catch(result => {
                    context.commit(mutationTypes.registerStop)
                    console.log('Result Errors:', result)
                    if (result.response === undefined){
                        context.commit(mutationTypes.setPhoneMsg, 'Something wrong. Please reload this page or try late.')
                        context.commit(mutationTypes.setIsPhoneInvalid, true)
                    } else {
                        console.log(result.response.data)

                        if (result.response.data['errors']['code']){
                            if (result.response.data['errors']['code'] == "permission_denied"){
                                context.commit(mutationTypes.setPhoneMsg, 'The session has expired, please refresh the page.')
                                context.commit(mutationTypes.setIsPhoneInvalid, true)
                            }
                        }
                        if (result.response.data['errors']['non_field_errors']){
                            let msg = result.response.data['errors']['non_field_errors'][0]['message']
                            context.commit(mutationTypes.setPhoneMsg, msg)
                            context.commit(mutationTypes.setIsPhoneInvalid, true)
                        }
                    }
                })
            })
    },
    [actionTypes.sendVerifyMailLink](context, credentials) {
        context.commit(mutationTypes.setIsLoading)

        return new Promise(resolve => {
            authApi
                .sendVerifyMailLink(credentials)
                .then(response => {
                    context.commit(mutationTypes.registerStop)
                    console.log('response:', response)

                    if (response.data['results']['action'] === 'send_email_verify_link' &&
                        response.data['results']['status'] === 'ok'){

                        console.log("Send verify mail link is OK!")
                        context.commit(mutationTypes.setIsLoading, false)
                        resolve(response.data['results'])
                    }
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
            })
    },
    [actionTypes.verificationEmail](context, credentials) {
        context.commit(mutationTypes.setIsLoading)

        return new Promise(resolve => {
            authApi
                .verificationEmail(credentials)
                .then(response => {
                    context.commit(mutationTypes.registerStop)
                    console.log('response:', response)

                    if (response.data['results']['action'] === 'verification_email' &&
                        response.data['results']['status'] === 'ok'){

                        console.log("Verification email is successful!")
                        context.commit(mutationTypes.setIsLoading, false)
                        resolve(response.data['results'])
                    }
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
            })
    },
    [actionTypes.authByCode](context, credentials) {
        context.commit(mutationTypes.registerStart)

        console.log(credentials)

        return new Promise(resolve => {
            authApi
                .authByCode(credentials)
                .then(response => {
                    context.commit(mutationTypes.registerStop)
                    console.log('response:', response)

                    context.commit(mutationTypes.registerSuccess, response.data['token'])
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(mutationTypes.registerStop)
                    console.log('Result Errors:', result)
                    console.log(result.response.data)

                    if (result.response === undefined){
                        context.commit(mutationTypes.setCodeMsg, 'Something wrong. Please reload this page or try late.')
                        context.commit(mutationTypes.setIsCodeInvalid, true)
                    } else {

                        let msg = result.response.data['errors']['non_field_errors'][0]['message']
                        context.commit(mutationTypes.setCodeMsg, msg)
                        context.commit(mutationTypes.setIsCodeInvalid, true)
                    }
                })
            })
    },
    [actionTypes.authByEmail](context, credentials) {
        context.commit(mutationTypes.registerStart)

        console.log(credentials)

        return new Promise(resolve => {
            authApi
                .authByEmail(credentials)
                .then(response => {
                    context.commit(mutationTypes.registerStop)
                    console.log('response:', response)

                    context.commit(mutationTypes.registerSuccess, response.data['token'])
                    resolve(response)
                })
                .catch(result => {
                    context.commit(mutationTypes.registerStop)
                    console.log('Result Errors:', result)
                    if (
                        result.response.status === 401
                        || result.response.status === 403
                        || result.response.data.errors.code === "authentication_failed"
                    ){
                        console.log("Need re-auth.")
                        router.push({ name: 'login' })
                    }
                    resolve(result.response)
                })
            })
    },
    [actionTypes.setCsrf](context, csrf){
        setItem('csrf', csrf)
    },
    [actionTypes.getCsrf](){
        return getItem('csrf')
    },
    [actionTypes.setAuthToken](context, token){
        let fullToken = token
        setItem('authToken', fullToken)
    },
    [actionTypes.getAuthToken](){
        return getItem('authToken')
    },
    [actionTypes.getLang](){
        return getItem('lang')
    },
    [actionTypes.setLang](context, value){
        setItem('lang', value)
    },
    [actionTypes.getCurrentUser](context) {
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
        authApi
            .getUser()
            .then(response => {
                context.commit(mutationTypes.registerStop)
                console.log('response:', response)

                context.commit(mutationTypes.setCurrentUser, response['data']['results'])
                context.commit(mutationTypes.setIsLoggedIn, true)
                context.commit(mutationTypes.setIsLoading, false)
                resolve(response.data)
            })
            .catch(result => {
                console.log('Result Errors:', result)
                context.commit(mutationTypes.setIsLoading, false)

                if (
                    result.response.status === 400
                    || result.response.status === 401
                    || result.response.status === 403
                    || result.response.data.errors.code === "authentication_failed"
                ){
                    // LOGOUT if something WRONG!
                    console.log(`Need re-auth. Details: ${result.response.data}`)
                    context.dispatch(actionTypes.logout)
                }
            })
        })
    },
    [actionTypes.updateCurrentUser](context, credentials) {
        console.log(credentials)
        context.commit(mutationTypes.setIsLoading, true)

        return new Promise(resolve => {
            authApi
                .updateUser(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.setCurrentUser, response['data']['results'])
                    context.commit(mutationTypes.setIsLoading, false)
                    resolve(response)
                })
                .catch(result => {
                    console.log('Result Errors:', result.response)
                    context.commit(mutationTypes.setIsLoading, false)
                    resolve(result.response)
                })
            })
    },
    [actionTypes.setPassword](context, credentials) {
        context.commit(mutationTypes.setIsLoading, true)

        return new Promise(resolve => {
            authApi
                .setPasswordUser(credentials)
                .then(response => {
                    console.log('response:', response)
                    context.commit(mutationTypes.setIsLoading, false)
                    resolve(response)
                })
                .catch(result => {
                    console.log('Result Errors:', result.response)
                    context.commit(mutationTypes.setIsLoading, false)
                    resolve(result.response)
                })
            })
    },
    [actionTypes.logout](context) {
        console.log("Logout")
        console.log(context)
        authApi
            .logout()
            .then(response => {
                console.log(`Successful logout ${response.data}`)
            })
            .catch(result => {
                console.log('Result Errors:', result.response.data)
            })
        setItem('authToken', '')

        context.commit(mutationTypes.setIsLoggedIn, false)
        router.push({ name: 'login' }).then(() => {
          window.location.reload();
        });
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}